import { memo } from 'react';
import Highlighter from 'react-highlight-words';
import removeAccents from 'remove-accents';
import { SearchDealerOption } from './FindDealer.types';

type FindDealerSearchContentProps = {
  option: SearchDealerOption;
  value: string;
};

export const FindDealerSearchContent = memo(({ option, value }: FindDealerSearchContentProps) => {
  if (option?.type === 'place') {
    return (
      // @ts-ignore
      <Highlighter
        highlightClassName='highlighted'
        autoEscape={true}
        sanitize={(text) => removeAccents(text)}
        textToHighlight={option?.name?.toString()}
        searchWords={[value?.toString()]}
      />
    );
  }
  if (option?.type === 'dealer') {
    return (
      <>
        {/* @ts-ignore */}
        <Highlighter
          highlightClassName='highlighted'
          autoEscape={true}
          sanitize={(text) => removeAccents(text)}
          textToHighlight={option.name?.toString()}
          searchWords={[value?.toString()]}
        />

        <small>
          {/* @ts-ignore */}
          <Highlighter
            highlightClassName='highlighted'
            autoEscape={true}
            sanitize={(text) => removeAccents(text)}
            textToHighlight={option.city?.toString() || ''}
            searchWords={[value?.toString()]}
          />{' '}
          {/* @ts-ignore */}
          <Highlighter
            highlightClassName='highlighted'
            autoEscape={true}
            sanitize={(text) => removeAccents(text)}
            textToHighlight={option.address?.toString() || ''}
            searchWords={[value?.toString()]}
          />
        </small>
      </>
    );
  }
  return null;
});
